// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__DTetV","Text":"styles_Text__JI886"};